import { useEffect } from 'react';

import { SimpleTooltip } from '@bambi/component-library/src/components/Tooltip/SimpleTooltip';
import {
  ArrowsUpDownIcon,
  QuestionMarkCircleIcon,
} from '@heroicons/react/24/outline';

import { useAppDispatch, useAppSelector } from 'src/app/store/hooks';
import Switch from 'src/common/primitives/Switch';
import { getStorageValue } from 'src/common/util/useLocalStorage/getStorageValue';
import { autoScrollCalendarStorageKey } from 'src/features/dispatch/constants';
import { setAutoScrollCalendar } from 'src/features/dispatch/dispatcher.slice';

export const AutoScrollCalendarToggle = () => {
  const dispatch = useAppDispatch();
  const autoScrollCalendar = useAppSelector(
    (state) => state.dispatcher.autoScrollCalendar
  );

  useEffect(() => {
    const autoScrollCalendar: string = getStorageValue(
      autoScrollCalendarStorageKey,
      'false'
    );

    const autoScrollCalendarBoolean = autoScrollCalendar === 'true';
    dispatch(setAutoScrollCalendar(autoScrollCalendarBoolean));
  }, [dispatch]);

  return (
    <div className="flex w-full items-center justify-between gap-1 text-xs">
      <div className="flex items-center gap-2">
        <ArrowsUpDownIcon className="h-4 w-4" />
        <div>Auto scroll</div>
        <SimpleTooltip
          trigger={
            <QuestionMarkCircleIcon className="h-4 w-4 text-primary-700" />
          }
          content="Auto scrolls the calendar to the current time."
        />
      </div>
      <Switch
        data-testid="auto-scroll-calendar-toggle"
        label="Auto scroll calendar"
        inputProps={{
          id: 'auto-scroll-calendar',
          onChange: () => {
            dispatch(setAutoScrollCalendar(!autoScrollCalendar));
          },
          value: autoScrollCalendar,
        }}
      />
    </div>
  );
};
